import { AuthContextProvider } from 'src/contexts/AuthContext';
import { Layout as BaseLayout } from 'antd';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import Vector from '../../../assets/images/vector.png';

export default function AdminAuthLayout() {
  return (
    <AuthContextProvider>
      <BaseLayout
        style={{
          minHeight: '100vh',
          backgroundImage: `url(${Vector})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
        }}
      >
        <Suspense>
          <Outlet />
        </Suspense>
      </BaseLayout>
    </AuthContextProvider>
  );
}
